import PageContentWrapper from "../../components/PageContentWrapper";
import { useEffect, useState } from "react";
import { getEnvironmentService } from "../../backend";
import GridList from "../../components/GridList";
import Heading from "../../components/Heading";
import { Divider } from "antd";
import { useParams } from "react-router";
import Search from "antd/lib/input/Search";
import { Component } from "@microtica/ms-engine-sdk";


const ResourceList = () => {
    const { projectId, envId } = useParams();
    const [components, setComponents] = useState<Component[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [filteredComponents, setFilteredComponents] = useState<Component[]>([]);


    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            const { data: { components } } = await getEnvironmentService().getComponents(projectId!)
            setComponents(components);
            setFilteredComponents(components);
            setLoading(false);
        }
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const filterComponents = (searchText: string) => {
        // TODO: Store input from here to analyze what the users need
        searchText.trim() === "" ?
            setFilteredComponents(components) :
            setFilteredComponents(components.filter(({ name }) => name.toLowerCase().includes(searchText.toLowerCase())));
    }

    return (
        <>
            <PageContentWrapper size="large">
                <Heading
                    title="Resources"
                    description="Choose from our ready-made components and expand your infrastructure"
                    level={3}
                />
                <Divider />

                <Search
                    placeholder="Search for database, blob storages, clusters etc."
                    onChange={event => filterComponents(event.target.value)}
                    onSearch={value => filterComponents(value)}
                />
                <br />
                <br />

                <GridList
                    itemsInRow={4}
                    loading={loading}
                    navigateState={filteredComponents.reduce((prev, curr) => {
                        return {
                            state: {
                                ...prev.state,
                                [curr.id]: curr
                            }
                        };
                    }, { state: {} })}
                    dataSource={filteredComponents.map(component => {
                        return {
                            key: component.id,
                            title: component.name,
                            description: component.description,
                            link: `/projects/${projectId}/environments/${envId}/infrastructure/resources/${component.id}/deploy`,
                            avatar: <img width={"25px"} src="https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" alt="" />,
                        }
                    })}
                />
            </PageContentWrapper>
        </>
    );
}

export default ResourceList;